export const CONFIRM_INPUT: any = {
    Paused: {
        label: 'You are about to place this product on Pause',
        info: `This will temporarily stop all deductions without penalties.<br>
        Possible reasons for doing this may be due to external or approved circumstances (e.g., force majeure).`
    },

    Resume: {
        label: 'You are about to Resume this product program',
        info: `This will resume scheduled deductions based on a new start date. Please ensure that this restart is <br>
        being made in good faith, with reasonable confidence that the driver is now able to resume payments.`
    }
};
